import { useState } from 'react';
import { type PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';
import { type SmartPhraseContext } from '@rsos/utils/SmartPhrases';
import {
  handleDynamicMessage,
  PRECONFIG_REQUEST_LOCATION,
} from '../../PreconfiguredMessages/AllMessages/utils';

type ChatWithMessageField = {
  messageField: { setText: (text: string) => void };
};

export const useRequestLocation = (
  chat: ChatWithMessageField | null | undefined,
  isConversationEnded: boolean,
  preconfiguredMessages: PreconfiguredResponse[] | undefined,
) => {
  const [locationError, setLocationError] = useState(false);

  const handleRequestLocation = async (locationData: SmartPhraseContext) => {
    setLocationError(false);
    if (chat && !isConversationEnded && preconfiguredMessages) {
      const locationMessage = preconfiguredMessages.find(
        message => message.title === PRECONFIG_REQUEST_LOCATION,
      );

      if (locationMessage) {
        try {
          const { body } = await handleDynamicMessage(
            locationMessage,
            locationData,
          );
          chat.messageField.setText(body);
        } catch {
          setLocationError(true);
        }
      }
    }
  };

  return { handleRequestLocation, locationError };
};
